import { ProgressSpinner } from 'primereact/progressspinner'
import { useContext, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import FormDataContext from '../../context/CreateProductsContext'
import { ModalTotalContext } from '../../context/ModalContext'
import { ButtonSubmit, Content, Title } from '../../GlobalStyle'
import api from '../../hooks/API'
import { Mask } from '../../hooks/Mask'
import { CurrencyInput } from '../../hooks/MaskInput'
import { useAddComponent, useDeleteComponent, useUpdateComponent } from '../../hooks/mutations'
import { reverseFormatMoney } from '../../hooks/removeFormat'
import BoxShadow from '../components/BoxShadowDiv/index'
import CheckBoxMade from '../components/CheckBox/index'
import Header from '../components/Header/index'
import InputComponent from '../components/Input'
import ModalTransform from '../components/Modal/ModalAsProduct'
import ModalConfirmDelete from '../components/Modal/ModalConfirmDelete'
import ModalEditComponent from '../components/Modal/ModalEditComponent/index'
import SelectOptions from '../components/Select'
import HomeTable from '../components/TableProduct/HomeTable'
import {
  FlexInputs,
  FormSection,
  FormActions,
  NewProduct,
  PageContainer,
  SectionSpacing,
} from './style'

const HomePage = () => {
  const [autoId, setAutoId] = useState(true)
  const [price, setPrice] = useState('')
  const [unity, setUnity] = useState('')
  const [priceByUnity, setPriceByUnity] = useState(0)

  const { openModal } = useContext(ModalTotalContext)
  const [clickedId, setClickedId] = useState()
  const [clickedEdit, setClickedEdit] = useState()

  const { mutate: addComponent } = useAddComponent()
  const { mutate: deleteComponent } = useDeleteComponent()
  const { mutate: editComponent } = useUpdateComponent()
  const { isLoading, data } = useQuery(['components'], () => api.getProducts())

  const products = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : []

  useEffect(() => {
    const unityNumber = Number(unity)
    const totalPrice = reverseFormatMoney(price)

    if (!unityNumber || unityNumber <= 0) {
      setPriceByUnity(0)
      return
    }

    setPriceByUnity(totalPrice / unityNumber)
  }, [price, unity])

  const ref = useRef()

  const clear = (product) => {
    product.nome.value = null
    product.id.value = ''
    setUnity('')
    setPrice('')
    setPriceByUnity(0)
  }

  const addProduct = async (e) => {
    e.preventDefault()

    const product = ref.current
    if (
      !product.nome.value ||
      !product.unidade.value ||
      !product.quantidade.value ||
      !product.valor.value
    ) {
      toast.warn('Usuário Teste - Demonstração')
    } else {
      const JSON = {
        id: reverseFormatMoney(product.id.value),
        nome: product.nome.value,
        unidade: product.unidade.value,
        quantidade: parseInt(product.quantidade.value),
        valor: reverseFormatMoney(product.valor.value),
      }

      addComponent(JSON)
      clear(product)
    }
  }

  const { setFormData } = useContext(FormDataContext)
  const navigate = useNavigate()
  localStorage.setItem('isLikeComponent', true)

  const handleTransform = (val) => {
    setFormData({
      id: '',
      nome: val.nome,
      gain: '',
      components: [],
      price: '',
      rival: '',
      quantidade: parseInt(val.quantidade),
      unidade: val.unidade,
      totalCost: val.valor,
    })
    navigate('/create_products', { state: true })
  }

  const deleteComponentButton = () => {
    deleteComponent(clickedId)
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          minHeight: '50vh',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )
  }

  return (
    <>
      <Content>
        <PageContainer>
          <Title>Criar componentes</Title>

          <SectionSpacing>
            <BoxShadow margin="0" overflow="visible">
              <Header title="Cadastrar novos componentes" />

              <FormSection>
                <NewProduct ref={ref} onSubmit={addProduct}>
                  <FlexInputs>
                    <InputComponent
                      name="id"
                      placeholder="Id"
                      disabled={autoId}
                      label="Código"
                    />

                    <InputComponent
                      name="nome"
                      placeholder="Nome do componente"
                      label="Nome *"
                    />

                    <SelectOptions />

                    <InputComponent
                      name="quantidade"
                      onChange={(e) => setUnity(Mask.onlyDigits(e.target.value))}
                      value={unity}
                      placeholder="Qtd"
                      label="Fração *"
                    />

                    <CurrencyInput
                      name="valor"
                      onChangeValue={(_, originalValue) => {
                        setPrice(originalValue)
                      }}
                      value={price}
                      placeholder="R$ 0,000"
                      label="Preço *"
                    />

                    <CurrencyInput
                      name="valor_unitario"
                      value={priceByUnity}
                      disabled
                      label="Preço por unidade"
                    />
                  </FlexInputs>

                  <FormActions>
                    <CheckBoxMade setAutoId={setAutoId} autoId={autoId} />

                    <ButtonSubmit width="220px" height="46px" type="submit">
                      Salvar
                    </ButtonSubmit>
                  </FormActions>
                </NewProduct>
              </FormSection>
            </BoxShadow>
          </SectionSpacing>

          <SectionSpacing>
            <BoxShadow id="list_product" flex margin="0">
              <Header title="Lista de componentes" />
              <HomeTable
                setClickedId={setClickedId}
                setClickedEdit={setClickedEdit}
                handleTransform={handleTransform}
                products={products}
                isHomePage
              />
            </BoxShadow>
          </SectionSpacing>
        </PageContainer>
      </Content>

      {openModal === 'editComponent' && (
        <ModalEditComponent prod={clickedEdit} callBack={editComponent} />
      )}
      {openModal === 'deleteComponent' && <ModalConfirmDelete callBack={deleteComponentButton} />}
      {openModal === 'transformComponent' && <ModalTransform callBack={deleteComponentButton} />}
    </>
  )
}

export default HomePage